import React from 'react';
import Menu from '@material-ui/core/Menu';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MenuItem from '@material-ui/core/MenuItem';
import Chip from '@material-ui/core/Chip';

import CommonContainer from "../../containers/Common";
import { useTranslation } from 'react-i18next';

export default (() => {
  const {t} = useTranslation();

  const commonContainer = CommonContainer.useContainer();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Chip
        // avatar={<AccountCircle />}
        icon={<AccountCircle />}
        label={`${commonContainer.userName}@${commonContainer.storeName}`}
        onClick={handleMenu}
      />
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={() => commonContainer.logout()}>{t('logout')}</MenuItem>
      </Menu>
    </>
  );
}) as React.FC;
